<div class="card">
    <div class="title mt-2">Change Password</div>

    <form [formGroup]="passwordForm" class="form-wrapper">
        <div class="mt-2">
            <div>
                <div class="custom-label">Old Password</div>
                <div>
                    <mat-form-field class="custom-form-field" floatLabel="never" appearance="outline">
                        <input type="password" formControlName="oldpassword" matInput placeholder="Type old password">
                    </mat-form-field>
                </div>
            </div>
        </div>  
        
        <div class="mt-2">
            <div class="custom-label">New Password</div>
            <div>
                <mat-form-field class="custom-form-field" floatLabel="never" appearance="outline">
                    <input type="password" formControlName="newpassword" matInput placeholder="Enter new password">
                </mat-form-field>
            </div>
        </div>

        <div class="mt-2">
            <div class="custom-label">Re-type Password</div>
            <div>
                <mat-form-field class="custom-form-field" floatLabel="never" appearance="outline">
                    <input type="password" formControlName="confirmpassword" matInput placeholder="Re-type password">
                </mat-form-field>
            </div>
        </div>

        <div class="error-style" *ngIf="errorMsg">{{passwordError}}</div>

        <div class="flex-el mt-2">
            <button mat-flat-button color="primary" style="width: 20%;" (click)="changePassword()" 
            [disabled]="passwordForm.invalid || passwordLoading">
                <p class="button_text" *ngIf = "!passwordLoading" > Save </p>
                    
                <img class = "button_loader" src="assets/images/Infinity-1.8s-200px.svg" alt="" *ngIf="passwordLoading">
            </button>
        </div>
    
    </form>


</div>
